import React, { useState } from 'react';
import {
  TextField,
  Button,
  Alert,
  Typography,
  Icon,
} from '@worthy-npm/worthy-common-ui-components';
import {
  FormContentNarrow,
  Step,
  StepContainer,
  NextStepButton,
  StepGridContainer,
} from '../../../styles/common';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectItemType, updateCarat } from '../../../slices/submitSlice';
import { StepProps } from '../common';
import StepTitle from '../../stepTitle';
import GA from '../../../data/GA';

function Weight({ next, stepName, idx, prev, title, stepCaption }: StepProps) {
  const [weight, setWeight] = useState<number>(0);
  const [isValid, setIsValid] = useState<boolean>(true);
  const [nextAvailability, setNextAvailability] = useState<boolean>(false);
  const [busy, setBusy] = useState(false);

  const itemType = useAppSelector(selectItemType);
  const dispatch = useAppDispatch();

  const validate = (value: string): void => {
    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue) || parsedValue >= 20 || parsedValue <= 0) {
      setWeight(0);
      setIsValid(false);
      setNextAvailability(false);
    } else {
      setWeight(parsedValue);
      setIsValid(true);
      setNextAvailability(true);
    }
  };

  const handleEnter = (e: any) => {
    if (e.key === 'Enter') {
      validate(e.target.value);

      if (isValid && nextAvailability) {
        dispatch(updateCarat(weight));
        next(e);
      }
    }
  };

  return (
    <StepContainer data-automation="central-carat-weight-step">
      <Step>
        <StepTitle
          idx={idx}
          stepCaption={stepCaption}
          prev={prev}
          stepTitle={title || 'Great! What is the largest diamond’s carat weight?'}
          stepName={stepName}
          stepNotice=""
        />
        <StepGridContainer>
          <FormContentNarrow>
            <TextField
              data-automation="central-carat-weight-input"
              inputProps={{ inputMode: 'decimal', type: 'number', step: 0.1, min: 0.1, max: 20.0 }}
              error={!isValid}
              placeholder="0.0 ct."
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                validate(e.target.value);
              }}
              onKeyDown={handleEnter}
              sx={{ input: { textAlign: 'center', minWidth: '10.3em' } }}
            />
          </FormContentNarrow>

          <Alert style={{ marginTop: '20px' }} variant="outlined" severity="info">
            <Typography>Tip: The most common diamond carat weight is 0.9ct.</Typography>
          </Alert>

          <NextStepButton>
            <Button
              disableElevation
              data-automation="central-carat-weight-next-button"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                if (weight > 0 && !busy) {
                  setBusy(true);
                  GA.submitNext(itemType, stepName, idx, weight.toString());
                  dispatch(updateCarat(weight));
                  next(e);
                  setTimeout(() => {
                    setBusy(false);
                  }, 150);
                }
              }}
              variant="contained"
              size="large"
              disabled={!nextAvailability}
              endIcon={<Icon.ContinueIcon />}
            >
              Continue
            </Button>
          </NextStepButton>
        </StepGridContainer>
      </Step>
    </StepContainer>
  );
}

export default Weight;
